export default __webpack_public_path__ + "static/media/cardRegisterPersonal.9ddceb74.png";